import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-172fd7b3")

_pushScopeId("data-v-172fd7b3")
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "uk-flex" }
const _hoisted_3 = { class: "footer__left" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "footer__address body-2" }, [
  /*#__PURE__*/_createTextVNode(" 63 Club Street"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Level 2"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Singapore 069437 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("a", { href: "mailto:hello@thoth.art" }, [
    /*#__PURE__*/_createVNode("b", null, "hello@thoth.art")
  ])
], -1)
const _hoisted_5 = { class: "footer__social" }
const _hoisted_6 = { class: "footer__right" }
const _hoisted_7 = { class: "uk-flex uk-child-width-1-3" }
const _hoisted_8 = { class: "footer__links__header body-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "footer__copyright body-4" }, " © 2024 Idea Ink Consulting ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: _ctx.icons.thoth,
      class: "footer__logo--thoth"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.socialMediaIcons, (icon, index) => {
            return (_openBlock(), _createBlock("a", {
              key: index,
              href: icon.link
            }, [
              _createVNode("img", {
                src: icon.image,
                alt: "footer__image"
              }, null, 8, ["src"])
            ], 8, ["href"]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linkLists, (linkList) => {
            return (_openBlock(), _createBlock("div", {
              key: linkList.header,
              class: "footer__links"
            }, [
              _createVNode("div", _hoisted_8, _toDisplayString(linkList.header), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(linkList.links, (link) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: link.text,
                  class: "footer__link body-2",
                  to: link.link
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(link.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_9
  ]))
})